//librerias
import { Component } from "@angular/core";

@Component({
  selector: "app-search-bar",
  templateUrl: "./search-bar.component.html",
})
export class SearchBarComponent {
  searchQuery: string = "";
}
